import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InstructionSearchService {
    private collapseAllSubject = new Subject<void>();
    collapseAll$ = this.collapseAllSubject.asObservable();

    triggerCollapseAll(): void {
        this.collapseAllSubject.next();
    }
}
